export default {
    pcd: "40",
    pname: "福岡県",
    header: "Go To Eatキャンペーン福岡 食事券 申込",
    explanation: "本サイトは、Go To Eatキャンペーン福岡 食事券の申込受付サイトです。\nGo To Eatキャンペーン福岡 食事券の申込方法をご案内しますので、以下に同意したうえでメールアドレスのご登録をお願いいたします。",
    personalinfo: "ご入力いただきました個人情報は、Go To Eatキャンペーン福岡 食事券の販売のために使用いたします。\n個人情報は、法令に基づく場合を除き、ご本人様の承諾なしに第三者（弊社業務委託先を除く）に提供することはありません。",
    cid: "gfukuoka",
    unitdetails: "10,000円（1,000円×10枚）／1セット",
    ticketvalue: 10000,
    unitprice: 8000,
    maxunits: 2,
    quantityoptions: [
        {value: "1", text: "1"},
        {value: "2", text: "2"}
    ],
    starttime: "0:00",
    ie11: true
};
